import { render, staticRenderFns } from "./logzio.vue?vue&type=template&id=2fe8f1f4&"
import script from "./logzio.vue?vue&type=script&lang=js&"
export * from "./logzio.vue?vue&type=script&lang=js&"
import style0 from "./logzio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports